export default {
  state: {
    urlQuery: null
    // isLoginPayroll: false
  },
  mutations: {
    setOvertimePageQuery(state, payload) {
      state.urlQuery = payload
    }
    // setLoginPayroll(state, payload) {
    //   state.isLoginPayroll = payload
    // }
  },
  actions: {},
  getters: {
    getOvertimePageQuery(state) {
      return state.urlQuery
    }
    // getLoginPayroll(state) {
    //   return state.isLoginPayroll
    // }
  }
}
